import styled from '@emotion/styled'
import { Link } from 'gatsby'
import React from 'react'
import BreakPoints from '../../styles/breakPoints'

const Wrapper = styled.article`
  position: relative;
  margin-bottom: 60px;
  border: solid 2px #e5e5e5;
  border-radius: 5px;
  padding: 20px;

  section {
    display: flex;
    justify-content: left;
    align-items: center;

    img {
      width: 110px;
      height: 110px;
      margin: 0 20px 0 0;
    }

    .author-wrap {
      position: relative;
      width: 100%;

      p {
        line-height: 2;

        &.author-name {
          font-size: 18px;
          font-weight: 600;

          span {
            font-weight: 400;
            font-size: 14px;
          }
        }

        &.author-job {
          position: relative;
          width: 100%;
          margin-left: 14px;

          &:before {
            display: block;
            content: '';
            position: absolute;
            width: 0;
            height: 0;
            top: 10px;
            left: -14px;
            border-left: 8px solid #3ec7b3;
            border-top: 4px solid transparent;
            border-bottom: 4px solid transparent;
          }

          a {
            margin-right: 15px;
          }
        }
      }
    }
  }

  .detail-txt {
    border-top: solid 1px #dcdee1;
    margin-top: 20px;
    padding-top: 15px;
    line-height: 1.8;
  }

  ${BreakPoints.large} {
  }
`

/**
 * コラム記事詳細：オーサ情報 蓑田 真吾（ミノダ シンゴ）
 * @constructor
 */
const columnAuthor001 = () => (
  <Wrapper>
    {/** TODO 川上申し送り事項：▼記事投稿（？）で作成された内容がここに入る予定 */}
    <section>
      <img src="/images/column/authors/a001.png" alt="蓑田 真吾" />
      <div className="author-wrap">
        <p className="author-name">
          蓑田 真吾<span>（ミノダ シンゴ）</span>
        </p>
        <p className="author-job">
          <Link
            to="https://www.minodashahorou.com/"
            target="_blank"
            rel="noreferrer"
          >
            みのだ社会保険労務士事務所
          </Link>
          代表 社会保険労務士
        </p>
      </div>
    </section>
    <div className="detail-txt">
      社会保険労務士(社労士)独立後は労務トラブルが起こる前の事前予防対策に特化。現在は様々な労務管理手法を積極的に取り入れ企業の人事労務業務をサポートしている。また、年金・医療保険に関する問題や労働法・働き方改革関する専門家として、実務相談を多く取り扱い、大手出版社からも書籍出版するなど、多方面で執筆活動を行う。
    </div>
  </Wrapper>
)

export default columnAuthor001
